import 'picturefill';
import 'objectFitPolyfill';
import 'es6-promise/auto';
import 'regenerator-runtime/runtime';
import elementClosest from 'element-closest';
import svg4everybody from 'svg4everybody';
import Stickyfill from 'stickyfilljs';
import UAParser from 'ua-parser-js';

require('intersection-observer');

elementClosest(window);

document.addEventListener('DOMContentLoaded', () => {
  const parser = new UAParser();
  const brower = parser.getBrowser().name;
  const isChrome = brower === 'Chrome';
  const isIe = brower === 'IE';
  const htmlElement = document.getElementsByTagName('html')[0];
  if (isIe) {
    htmlElement.classList.add('ie');
  }
  if (isChrome) {
    htmlElement.classList.add('chrome');
  }
  svg4everybody();
});

document.addEventListener('load', () => {
  const sticky = document.querySelectorAll('.sticky');
  Stickyfill.add(sticky);
});
